import React, {useEffect} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {postSignInSocialToken} from '../../../../redux/actions/auth/authActions';
import {mainPath, rootMainPath} from '../../../../routes/paths';
import Preloader from '../../../Components/Preloader';
import {notifyError} from '../../../../helpers/notifySnack';
import {socialsProvider} from '../../../../redux/actions/profile/profileActions';
import {useTranslation} from 'react-i18next';

const Google = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const {t} = useTranslation();
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const code = queryParams.get('code');
        if (code) {
            if (localStorage.getItem('token')) {
                dispatch(socialsProvider('google', location.search)).then((res) => {
                    history.push(mainPath.userDetails);
                });
            }
            else {
                dispatch(postSignInSocialToken('google', location.search)).then((res) => {
                    if (res?.payload?.data?.token) {
                        localStorage.setItem('token', res.payload.data.token.accessToken);
                        localStorage.setItem('refreshToken', res.payload.data.token.accessToken);
                        history.push(rootMainPath);
                    } else {
                        if (res.payload.status !== 500) {
                            notifyError(t('all.authToken'));
                        }
                        history.push('/');
                    }
                });
            }
        }
        else{
            if (localStorage.getItem('token')) {
                history.push(mainPath.userDetails);
            } else {
                history.push('/');
            }
        }
    }, [location]);
    return <Preloader/>;
};

export default Google;
